import React, { Fragment } from 'react';

const InsurancePolicyCoverageSF = () => (
  <Fragment>
    <ul>
      <li>
        <strong>Coverage when you're offline:</strong>
        <p>
          Autzu maintains commercial automobile insurance, which covers the
          cost of injuries or damages up to a combined single limit of
          $100,000.
        </p>
      </li>
      <li>
        <strong>
          Coverage when you’re online and available for a trip (i.e. Uber):
        </strong>
        <p>
          Autzu maintains commercial automobile insurance, which covers the
          cost of injuries or damages up to a combined single limit of
          $125,000.
        </p>
      </li>
      <li>
        <strong>
          Coverage when you’re en route or on a trip (i.e. Uber):
        </strong>
        <p>
          Uber maintains insurance that covers at least $1,000,000 for
          property damage and injuries to riders and third parties involved
          in an accident, no matter who’s at fault.{' '}
        </p>
      </li>
    </ul>
    <br />
    <p>
      <strong>
        Note: The maximum deductible of $2,500 applies if you are “at
        fault” for an accident during any of the above stages unless you
        opt-in to Autzu’s reduced deductible plan, then your deductible
        becomes $1,000.
      </strong>
    </p>
    <p>
      See <a href="#accidents-and-insurance">Accidents and Insurance</a>{' '}
      section for full details.
    </p>
  </Fragment>
);

export default InsurancePolicyCoverageSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/InsurancePolicyConverageSF.js